import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import AdditionalDetailsSectionImage from './AdditionalDetailsSectionImage/AdditionalDetailsSectionImage';

const AdditionalDetailsSectionImagePicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.image.name]: (<AdditionalDetailsSectionImage relationship={resource.relationship(fr.relationships.image.name)} />),
  }, null);
};

AdditionalDetailsSectionImagePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
AdditionalDetailsSectionImagePicker.defaultProps = {};

export default AdditionalDetailsSectionImagePicker;
